import { fetchAuthConfigForDataSync } from './DataSync';
import { UnifiedAuthView } from './LowLevelUnifiedAuth';
import { DataSyncIntroScreen, DataSyncSuccessScreen } from './DataSync';
import { UniversalAuthTracker } from './UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DataSyncAuthForm({
  portalId,
  appId,
  accountId,
  onComplete,
  onSetupSyncClick,
  onDoThisLaterClick,
  trackingSource,
  onCancel
}) {
  return /*#__PURE__*/_jsx(UnifiedAuthView, {
    isModal: false,
    isReauth: !!accountId,
    portalId: portalId,
    onComplete: account => {
      if (trackingSource) {
        UniversalAuthTracker.track('app-management', {
          applicationId: appId,
          source: trackingSource,
          action: accountId ? 'APP_RECONNECTED' : 'APP_CONNECTED'
        });
      }
      if (onComplete) onComplete(account);
    },
    onCancel: onCancel,
    introScreen: DataSyncIntroScreen,
    fetchAuthConfig: fetchAuthConfigForDataSync(portalId, appId, accountId, undefined /* don't override the hublet */),
    successScreen: ({
      appName,
      authResponse
    }) => /*#__PURE__*/_jsx(DataSyncSuccessScreen, {
      portalId: portalId,
      appId: appId,
      appName: appName,
      account: authResponse,
      onSetupSyncClick: onSetupSyncClick,
      onDoThisLaterClick: onDoThisLaterClick
    })
  });
}